module.exports = __webpack_public_path__ + "img/nodejs_logo.89ccb090.svg";